import { create } from 'zustand'

import { getErrorMessage } from '@/shared/lib/errorMessage'
import { toast } from '@/shared/lib/toast'

import * as quotationApi from '../api/quotation.api'

export const useQuotationStore = create((set) => ({
  quotations: [],
  quotation: null,
  meta: {
    page: 1,
    limit: 5,
    total: 0,
    totalPages: 0,
  },

  createQuotation: async (payload) => {
    try {
      const response = await quotationApi.createQuotation(payload)

      toast.success(response.message || 'Quotation created successfully')

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to create quotation'))

      throw error
    }
  },

  getQuotations: async (params = {}) => {
    try {
      const response = await quotationApi.getQuotations(params)

      set({
        quotations: response.data ?? [],
        meta: response.meta ?? {
          page: params.page || 1,
          limit: params.limit || 5,
          total: 0,
          totalPages: 0,
        },
      })

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to fetch quotations'))
      throw error
    }
  },

  getQuotationById: async (id) => {
    try {
      const response = await quotationApi.getQuotationById(id)

      set({
        quotation: response.data,
      })

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to fetch quotation'))

      throw error
    }
  },

  getQuotationEmailPreview: async (id) => {
    try {
      const response = await quotationApi.getQuotationEmailPreview(id)

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to load email preview'))

      throw error
    }
  },

  updateQuotation: async (id, payload) => {
    try {
      const response = await quotationApi.updateQuotation(id, payload)

      toast.success(response.message || 'Quotation updated successfully')

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to update quotation'))

      throw error
    }
  },

  deleteQuotation: async (id) => {
    try {
      const response = await quotationApi.deleteQuotation(id)

      toast.success(response.message || 'Quotation deleted successfully')

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to delete quotation'))

      throw error
    }
  },

  sendQuotation: async (id, emailData) => {
    try {
      const response = await quotationApi.sendQuotation(id, emailData)

      toast.success(response.message || 'Quotation sent successfully')

      return response.data
    } catch (error) {
      toast.error(getErrorMessage(error, 'Failed to send quotation'))

      throw error
    }
  },
}))
